import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { SimulationSummaryDownloadClientResponse } from '../@types/SimulationSummaryDownload'

type Store = {
  showSimplifiedReport?: boolean
  showCompleteReport?: boolean
  simulationSummaryDownload: SimulationSummaryDownloadClientResponse | null
  setSimulationSummaryDownload: (
    value: SimulationSummaryDownloadClientResponse,
  ) => void
  setSimplifiedReport: (showSimplifiedReport: boolean) => void
  setShowCompleteReport: (showCompleteReport: boolean) => void
}

export const useSimulationSummaryDownloadStore = create<Store>()(
  devtools(
    (set) => ({
      showSimplifiedReport: false,
      showCompleteReport: false,
      simulationSummaryDownload: null,
      setSimulationSummaryDownload: (simulationSummaryDownload) =>
        set({ simulationSummaryDownload }),
      setSimplifiedReport: (showSimplifiedReport) =>
        set({ showSimplifiedReport }),
      setShowCompleteReport: (showCompleteReport) =>
        set({ showCompleteReport }),
    }),
    { name: 'SimulationSummaryDownloadStore' },
  ),
)
